import { PipoProvider as $, UNSUPPORT_PAY_PAYMENT_METHODS_ID_MAP as Te, WHOLE_PAYMENT_METHODS_ID_MAP as Le, UNSUPPORTED_BIND_PAYMENT_METHODS_ID_LIST as Ie, SUPPORT_BIND_PAYMENT_METHODS_ID_MAP as Se, SUPPORT_PAYMENT_METHODS_ID_MAP as K, SupportedModel as ae, cardTypeMap as we, isGeneralCCDC as re, chunkString as ne, BANK_CARD_REGEX_LIST as Oe, pickNumeric as Ee, validator as De, formatExpiryDate as xe, postalCode as Ne, ISOCodeToCountry as Ae, formatAmount as Z, UNSUPPORT_MERGE_LIST as ee, pickNumericAlphabet as Be } from "@pipo-lib/utils";
import $e, { useMemo as x, useRef as te, useCallback as B, useState as j, useEffect as A, useImperativeHandle as ke } from "react";
import Ue from "lodash.intersectionwith";
import { useRequest as U, useMultiSelect as Me, useTimer as Ve, useClipboardCopy as Fe, useDeepMemo as Re, useBoolean as je, useControlled as He } from "@byted/hooks";
import G from "lodash.filter";
import qe from "lodash.keys";
import Ge from "lodash.pick";
var Je = Object.defineProperty, Ye = Object.defineProperties, Ke = Object.getOwnPropertyDescriptors, ie = Object.getOwnPropertySymbols, We = Object.prototype.hasOwnProperty, ze = Object.prototype.propertyIsEnumerable, se = (n, t, e) => t in n ? Je(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e, W = (n, t) => {
  for (var e in t || (t = {}))
    We.call(t, e) && se(n, e, t[e]);
  if (ie)
    for (var e of ie(t))
      ze.call(t, e) && se(n, e, t[e]);
  return n;
}, z = (n, t) => Ye(n, Ke(t));
const Ht = (n) => {
  const {
    paymentMethodsList: t,
    storedPaymentMethodsList: e,
    type: o = "pay",
    unavailablePaymentMethodsList: i,
    unavailableStoredPaymentMethodsList: l,
    wholePaymentMethodsIdMap: a = Le,
    unsupportedBindPaymentMethodsIdMap: p = Ie,
    supportBindPaymentMethodsIdMap: c = Se,
    supportPaymentMethodsIdMap: d = K,
    paymentMethodItemsMap: m
  } = n, { getPMConfig: f, noSavingBox: s } = $.useContext(), {
    formatPaymentMethodList: g,
    formatStoredPaymentMethodList: b,
    formatUnavailableStoredPaymentMethodList: I,
    formatUnavailableOtherPaymentMethodList: _
  } = m || {}, E = x(() => {
    if (g)
      return g;
    const M = (y) => y.model === ae.PayOnToken || y.model === ae.TokenizeAndPay;
    return t.filter((y) => o === "pay" ? Te.includes(y.paymentMethodId) ? !1 : s && y.model ? M(y) && y.paymentMethodId in d : y.paymentMethodId in d : o === "bind" ? !a[y.paymentMethodId] || p.includes(y.paymentMethodId) ? !1 : y.model ? M(y) : y.paymentMethodId in c : !1).filter((y) => {
      const O = (e.filter(
        (r) => r.paymentMethodId === y.paymentMethodId
      ) || []).length, L = f(y.paymentMethodId), { bindLimit: v = -1 } = L;
      return v < 0 ? !0 : v > O;
    }).map((y) => z(W({}, a[y.paymentMethodId]), {
      type: "others",
      elements: y.elements,
      model: y.model,
      fee_under_taker: y.fee_under_taker,
      payment_fee_amount: y.payment_fee_amount,
      quote_fee_amount: y.quote_fee_amount,
      defaultSelected: y == null ? void 0 : y.defaultSelected,
      marketingEventText: y.marketingEventText,
      cardType: y.card_type
    }));
  }, [
    g,
    t,
    o,
    c,
    a,
    p,
    d,
    e,
    f,
    s
  ]), C = x(() => _ || (i || []).filter((M) => o === "bind" ? !1 : M.paymentMethodId in a).map((M) => z(W({}, a[M.paymentMethodId]), {
    type: "others",
    elements: M.elements,
    model: M.model,
    unavailableErrorCode: M.unavailableCode || ""
  })), [
    _,
    i,
    o,
    a
  ]), {
    formatStoredPaymentMethodList: h,
    formatUnavailableStoredPaymentMethodList: T
  } = x(() => {
    if (b && I)
      return {
        formatStoredPaymentMethodList: b,
        formatUnavailableStoredPaymentMethodList: I
      };
    const M = o === "bind" ? a : d, y = (r) => z(W({}, M[r.paymentMethodId]), {
      type: "stored",
      token: r.token,
      title: r.title,
      expiryDate: r == null ? void 0 : r.expiryDate,
      isPrimary: (r == null ? void 0 : r.isPrimary) || !1,
      isExpired: (r == null ? void 0 : r.isExpired) || !1,
      balance: r == null ? void 0 : r.balance,
      defaultSelected: r == null ? void 0 : r.defaultSelected,
      fee_under_taker: r.fee_under_taker,
      payment_fee_amount: r.payment_fee_amount,
      quote_fee_amount: r.quote_fee_amount,
      marketingEventText: r.marketingEventText,
      isAgreementBound: r.isAgreementBound
    }), O = (r) => z(W({}, y(r)), {
      unavailableErrorCode: r.unavailableCode || ""
    }), L = e.filter((r) => M[r.paymentMethodId]).map(y), v = [];
    return (l || []).forEach((r) => {
      M[r.paymentMethodId] && v.push(
        O(r)
      );
    }), {
      formatStoredPaymentMethodList: L,
      formatUnavailableStoredPaymentMethodList: v
    };
  }, [
    b,
    I,
    o,
    a,
    d,
    e,
    l
  ]);
  return {
    formatPaymentMethodList: E,
    formatStoredPaymentMethodList: h,
    formatUnavailableStoredPaymentMethodList: T,
    formatUnavailableOtherPaymentMethodList: C
  };
};
var Qe = Object.defineProperty, Xe = Object.defineProperties, Ze = Object.getOwnPropertyDescriptors, le = Object.getOwnPropertySymbols, et = Object.prototype.hasOwnProperty, tt = Object.prototype.propertyIsEnumerable, de = (n, t, e) => t in n ? Qe(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e, Q = (n, t) => {
  for (var e in t || (t = {}))
    et.call(t, e) && de(n, e, t[e]);
  if (le)
    for (var e of le(t))
      tt.call(t, e) && de(n, e, t[e]);
  return n;
}, X = (n, t) => Xe(n, Ze(t));
function qt(n) {
  const { paymentMethodsList: t, onGetUnifiedBinDetail: e } = n, o = e !== void 0, { t: i, getErrorText: l, state: a } = $.useContext(), { cardType: p = "", prepaidType: c = "", countryOrRegion: d } = a, { cardTypeStarling: m } = we(p), f = c.toLowerCase() === "prepaid" ? "prepaid" : "noprepaid", s = i("pipo_common_payin_ph_card_number"), g = 23, b = te(), I = $e.createRef(), _ = x(() => t.filter((u) => {
    const S = K[u.paymentMethodId];
    return S && re(S);
  }).map((u) => X(Q({}, K[u.paymentMethodId]), {
    cardType: u.card_type
  })), [t]), E = B((u) => (u.includes(" ") && (u = u == null ? void 0 : u.replace(/\s/g, "")), u.length > 4 ? ne(u, 4).join(" ") : u), []), C = B(
    (u, S, w) => {
      const D = S.length > u.length ? "insert" : "delete";
      return w !== 0 && w % 5 === 0 ? w + (D === "insert" ? 1 : -1) : w;
    },
    []
  ), [h, T] = j(), [M, y] = j(), O = te(0), L = te(), v = B(
    (u) => {
      var S, w, D;
      const N = (S = Oe) == null ? void 0 : S.filter((R) => new RegExp(R.cardBinRegex).test(u)), k = Ue(
        N,
        _,
        (R, q) => {
          var Y;
          return (R == null ? void 0 : R.paymentMethod) === ((Y = q == null ? void 0 : q.paymentMethod) == null ? void 0 : Y.paymentMethod);
        }
      ), F = _ == null ? void 0 : _.find(
        (R) => {
          var q, Y;
          return ((q = R == null ? void 0 : R.paymentMethod) == null ? void 0 : q.paymentMethod) === ((Y = k[0]) == null ? void 0 : Y.paymentMethod);
        }
      );
      F && (console.log("use offline data: ", u), b.current = F, T({
        payment_method: F.paymentMethod.paymentMethod,
        card_brand: F.paymentMethod.paymentMethod,
        card_type: "UNKNOWN",
        cvv_length: ((w = F.paymentMethod.configuration) == null ? void 0 : w.cvv_length) || [],
        card_brand_length: ((D = F.paymentMethod.configuration) == null ? void 0 : D.card_brand_length) || []
      }));
    },
    [_]
  ), r = B(
    (u) => {
      !e || L.current !== u && ((!u || u.length < 6) && (T(void 0), L.current = void 0), u && u.length >= 6 && (L.current = u, setTimeout(() => {
        L.current === u && (O.current = Date.now(), e(u, d).then((S) => {
          if (L.current === u)
            if (S.result_code === "success")
              S.card_brand = S.payment_method, T(S);
            else
              throw new Error("GetUnifiedBinDetail failed");
        }).catch((S) => {
          console.error(S), O.current = 0, L.current = void 0, T(void 0), v(u);
        }));
      }, Math.max(1e3 - (Date.now() - O.current), 0))));
    },
    [d, e]
  ), P = B(
    (u) => {
      setTimeout(() => {
        !h && u && u.length >= 6 && v(u);
      }, 500);
    },
    [h, v]
  );
  A(() => {
    var u, S;
    if (h) {
      const w = _ == null ? void 0 : _.find(
        (D) => {
          var N;
          return ((N = D == null ? void 0 : D.paymentMethod) == null ? void 0 : N.paymentMethod) === (h == null ? void 0 : h.payment_method);
        }
      );
      if (w) {
        b.current = X(Q({}, w), {
          paymentMethod: X(Q({}, w.paymentMethod), {
            configuration: X(Q({}, w.paymentMethod.configuration), {
              cvv_length: h.cvv_length || ((u = w.paymentMethod.configuration) == null ? void 0 : u.cvv_length),
              card_brand_length: h.card_brand_length || ((S = w.paymentMethod.configuration) == null ? void 0 : S.card_brand_length)
            })
          })
        });
        return;
      }
    }
    b.current = void 0;
  }, [h]);
  const V = {
    validCardBIN: (u = "") => h ? Boolean(b.current) : !1,
    merchantUnifiedBinDetail: (u = "") => {
      if (!o)
        return !0;
      if ((u == null ? void 0 : u.replace(/\s/g, "")).length > 6)
        try {
          const w = h == null ? void 0 : h.card_type, D = h == null ? void 0 : h.is_prepaid, N = {
            cardTypeCheck: !0,
            prepaidTypeCheck: !0
          };
          if ((p.toLowerCase() === "debit" || p.toLowerCase() === "credit") && (N.cardTypeCheck = (w == null ? void 0 : w.toLowerCase()) === p.toLowerCase()), c.toLowerCase() === "prepaid" || c.toLowerCase() === "non-prepaid") {
            const k = c.toLowerCase() === "prepaid";
            N.prepaidTypeCheck = D === k;
          }
          return N.cardTypeCheck && N.prepaidTypeCheck;
        } catch (w) {
          return !0;
        }
      return !0;
    },
    pmUnifiedBinDetail: (u = "") => {
      var S;
      if (!o)
        return !0;
      if ((u == null ? void 0 : u.replace(/\s/g, "")).length > 6)
        try {
          const D = h == null ? void 0 : h.card_brand.toLocaleLowerCase(), N = h == null ? void 0 : h.card_type.toLocaleLowerCase(), k = _.find(
            (R) => R.paymentMethod.paymentMethod.toLocaleLowerCase() === D
          );
          y(k);
          const F = (S = k == null ? void 0 : k.cardType) == null ? void 0 : S.toLocaleLowerCase();
          return !F || N === "unknown" || N === F;
        } catch (D) {
          return !0;
        }
      return !0;
    },
    validLength: (u = "") => {
      var S, w;
      const D = u == null ? void 0 : u.replace(/\s/g, ""), N = b.current, k = (S = N == null ? void 0 : N.paymentMethod) == null ? void 0 : S.configuration;
      return (w = k == null ? void 0 : k.card_brand_length) == null ? void 0 : w.includes(D.length);
    },
    number: (u = "") => {
      const S = u == null ? void 0 : u.replace(/\s/g, "");
      return /^[0-9]+$/.test(S);
    },
    luhn: (u = "") => {
      const S = u == null ? void 0 : u.replace(/\s/g, "");
      return De.luhn(S);
    }
  }, J = B(
    (u) => {
      var S;
      const w = u == null ? void 0 : u.type;
      switch (w) {
        case "required":
          return l(w, i("pipo_common_payin_card_number"));
        case "validCardBIN":
          return i("pipo_common_error_card_not_supported");
        case "validLength":
          return i("pipo_common_error_card_number_length");
        case "number":
          return i("pipo_common_error_card_check");
        case "luhn":
          return l(w, i("pipo_common_payin_card_number"));
        case "merchantUnifiedBinDetail":
          return i(
            `pipo_payin_state_cashier_error_${m}_${f}`
          );
        case "pmUnifiedBinDetail": {
          const D = M == null ? void 0 : M.paymentMethod.displayName, N = (S = M == null ? void 0 : M.cardType) == null ? void 0 : S.toLocaleLowerCase();
          return i(
            `pipo_payin_state_cashier_error_${N}_card`,
            { value: D || "" }
          );
        }
        default:
          return "";
      }
    },
    [l, i, M]
  ), Ce = B(
    (u, S, w) => {
      if (!u) {
        r(void 0), b.current = void 0, S(u), w(u);
        return;
      }
      if (/^[\d\s]*$/.test(u)) {
        const D = Ee(u);
        r(D), S(D), w(D);
      }
    },
    [r]
  );
  return {
    cardNumberInputRef: I,
    cardBrands: _,
    cardNoValidator: V,
    currentCardBrand: b.current,
    cardNoPlaceholder: s,
    cardNoMaxLength: g,
    formatValue: E,
    formatCursor: C,
    getCardNoError: J,
    onCardNoChange: Ce,
    cardDetail: h,
    onCardNumberBlur: P
  };
}
const Gt = (n) => {
  const { value: t, onChange: e } = n, { month: o, year: i } = t, [l, a] = j(), p = x(() => {
    if (!o)
      return "";
    let m = xe(o + i);
    return l === "deleteContentBackward" && !i && m.length === 3 && (m = m.slice(0, -1)), m;
  }, [o, i, l]), c = (m = "") => {
    const f = { month: "", year: "" };
    if (m.indexOf("/") === -1) {
      if (!m)
        return f;
      if (m.length === 3) {
        const _ = m.slice(0, 2), E = m.slice(2, 3);
        return {
          month: _,
          year: E
        };
      }
    }
    const [s = "", g = ""] = m.split("/"), b = s.slice(0, 2), I = g.slice(0, 2);
    return {
      month: b,
      year: I
    };
  }, d = B(
    (m) => {
      const f = m.nativeEvent.inputType;
      a(f);
      let s = m.target.value;
      if (f === "insertText") {
        const I = m.nativeEvent.data;
        if (isNaN(I))
          return;
      } else
        f === "deleteContentBackward" && s.length === 2 && (s = s.slice(0, -1));
      const { month: g, year: b } = c(s);
      e == null || e(g, b);
    },
    [e]
  );
  return {
    formatExpiryValue: p,
    handleExpiryDateChange: d
  };
}, Jt = () => {
  const { t: n, getErrorText: t } = $.useContext();
  return {
    getExpiryDateError: B(
      (o) => {
        const i = o == null ? void 0 : o.type;
        switch (i) {
          case "required":
            return t(i, n("pipo_common_payout_expire_date"));
          case "pattern":
            return t(i, n("pipo_common_payout_expire_date"));
          case "dateTooFar":
            return n("pipo_common_error_year_too_far");
          case "cardExpired":
            return n("pipo_common_error_card_expired");
          default:
            return "";
        }
      },
      [t, n]
    )
  };
};
function Yt(n, t, e) {
  var o, i, l;
  const { t: a, getErrorText: p } = $.useContext(), c = a("pipo_common_payin_ph_cvv_cvc"), d = a("pipo_common_payin_security_code"), m = {
    required: !0,
    pattern: new RegExp(
      `^[0-9]{${((i = (o = n == null ? void 0 : n.paymentMethod) == null ? void 0 : o.configuration) == null ? void 0 : i.cvv_length) || ((l = [3, 4]) == null ? void 0 : l.join(","))}}$`
    )
  }, f = B(
    (s) => {
      const g = s == null ? void 0 : s.type;
      return p(g, a("pipo_common_payin_security_code"));
    },
    [p, a]
  );
  return A(() => {
    n && (e == null ? void 0 : e("cvv")) && t && t("cvv").catch(() => null);
  }, [n]), {
    cvvTitle: d,
    cvvValidator: m,
    getCVVError: f,
    cvvPlaceholder: c
  };
}
function Kt(n) {
  const { t, getErrorText: e } = $.useContext(), o = Ne.list[n], l = {
    required: !0,
    pattern: (o == null ? void 0 : o.pattern) || /^[0-9a-zA-Z]*$/
  }, a = B(
    (p) => {
      const c = p == null ? void 0 : p.type;
      return e(c, t("pipo_common_payin_postalcode"));
    },
    [e, t]
  );
  return {
    postalCodeValidator: l,
    getPostalCodeError: a,
    postalCodeFormatter: o == null ? void 0 : o.formatter,
    postalCodeMaxLength: o == null ? void 0 : o.maxLength,
    postalValidInput: o == null ? void 0 : o.validInput
  };
}
const Wt = (n) => {
  const {
    onFetchDistrict: t,
    setValue: e,
    trigger: o,
    clearErrors: i,
    countryRange: l,
    value: a = { region: "", state: "", city: "" },
    onChange: p
  } = n, { region: c, state: d, city: m } = a, {
    data: f = [],
    loading: s,
    run: g
  } = U(() => t(""), {
    auto: !0
  }), {
    data: b = [],
    loading: I,
    run: _,
    changeData: E
  } = U(t, {
    onSuccess: (v = []) => {
      const r = v.filter(
        (P) => !(P.code === "" && P.name === "")
      );
      if (r.length === 0) {
        const P = f.filter((V) => V.code === c)[0];
        E([...r, P]);
      }
    }
  }), {
    data: C = [],
    loading: h,
    run: T,
    changeData: M
  } = U(t, {
    onSuccess: (v = []) => {
      const r = v.filter(
        (P) => !(P.code === "" && P.name === "")
      );
      if (r.length === 0) {
        const P = b.filter((V) => V.name === d)[0];
        M([...r, P]);
      }
    }
  });
  A(() => {
    g().then((v) => {
      !v || (v.find((r) => r.code === c) ? (e("billing_country_region", c), o("billing_country_region")) : (e("billing_country_region", void 0), e("billing_state", void 0), e("billing_city", void 0), i(["billing_state", "billing_city"]), o("billing_country_region"), p({})));
    });
  }, [c]), A(() => {
    var v;
    !f || !Array.isArray(f) || c && !s && _(
      (v = f == null ? void 0 : f.find((r) => r.code === c)) == null ? void 0 : v.geoname_id.toString()
    ).then((r) => {
      if (!!Array.isArray(r))
        if (r.find((P) => P.name === d))
          e("billing_state", d), o("billing_state");
        else {
          if (r.length === 0) {
            const P = Ae(c, f);
            if (d === P) {
              e("billing_state", d), o("billing_state");
              return;
            }
          }
          e("billing_state", void 0), e("billing_city", void 0), i("billing_city"), o("billing_state"), p({ region: c });
        }
    });
  }, [c, f, d, s]), A(() => {
    var v;
    !b || !Array.isArray(b) || d && !I && T(
      (v = b == null ? void 0 : b.find((r) => r.name === d)) == null ? void 0 : v.geoname_id.toString()
    ).then((r) => {
      !Array.isArray(r) || (r.find((P) => P.name === m) || r.length === 0 && m === d ? (e("billing_city", m), o("billing_city")) : (e("billing_city", void 0), o("billing_city"), p({ region: c, state: d })));
    });
  }, [d, b, m, I]);
  const y = {
    loading: s,
    list: typeof l != "undefined" ? f.filter((v) => l.includes(v.code)) : f,
    disabled: s
  }, O = {
    loading: I,
    list: b,
    disabled: !I && !c
  }, L = {
    loading: h,
    list: C,
    disabled: !h && !d
  };
  return {
    list: G([y, O, L], Boolean),
    map: G(
      {
        region: y,
        province: O,
        city: L
      },
      Boolean
    )
  };
};
function nt(n) {
  const { ref: t, activePath: e, isValid: o = !1, onValidate: i } = n;
  A(() => {
    var l;
    ((l = t == null ? void 0 : t.current) == null ? void 0 : l.initPath) === e && (i == null || i(o));
  }, [o]);
}
var ot = Object.defineProperty, ce = Object.getOwnPropertySymbols, rt = Object.prototype.hasOwnProperty, at = Object.prototype.propertyIsEnumerable, pe = (n, t, e) => t in n ? ot(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e, oe = (n, t) => {
  for (var e in t || (t = {}))
    rt.call(t, e) && pe(n, e, t[e]);
  if (ce)
    for (var e of ce(t))
      at.call(t, e) && pe(n, e, t[e]);
  return n;
};
const zt = (n, t) => {
  const {
    initPath: e = "payment-methods",
    initParams: o = {},
    instanceMethods: i = {}
  } = t || {}, [l, a] = j(o), { isValid: p, onValidate: c } = o, {
    selected: [d],
    select: m
  } = Me(
    [
      "payment-methods",
      "pi-list",
      "pi-detail",
      "ccdc",
      "boleto",
      "pix",
      "oxxo",
      "voucher"
    ],
    {
      isMulti: !1,
      defaultSelected: [e]
    }
  );
  return nt({
    ref: n,
    activePath: d,
    isValid: p,
    onValidate: c
  }), ke(n, () => oe({
    initPath: e,
    handleAction: (f) => {
      if (f.type === "redirect") {
        const { url: g } = f.payload;
        g && (window.location.href = g);
        return;
      }
      const { path: s } = f.payload;
      !s || (a((g) => oe(oe({}, g), f.payload.params || {})), m(s));
    }
  }, i)), { activePath: d, routerParams: l };
}, Qt = (n) => {
  const { expirationTime: t = "", onTimeUp: e } = n, o = te(new Date(t)), { days: i, hours: l, minutes: a, seconds: p } = Ve(o.current, {
    onComplete: e,
    isCountDown: !0
  });
  return A(() => {
    o.current = new Date(t);
  }, [t]), t ? {
    hours: String(parseInt(i) * 24 + parseInt(l)),
    minutes: a,
    seconds: p
  } : {};
};
var it = Object.defineProperty, st = Object.defineProperties, lt = Object.getOwnPropertyDescriptors, ue = Object.getOwnPropertySymbols, dt = Object.prototype.hasOwnProperty, ct = Object.prototype.propertyIsEnumerable, _e = (n, t, e) => t in n ? it(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e, pt = (n, t) => {
  for (var e in t || (t = {}))
    dt.call(t, e) && _e(n, e, t[e]);
  if (ue)
    for (var e of ue(t))
      ct.call(t, e) && _e(n, e, t[e]);
  return n;
}, ut = (n, t) => st(n, lt(t)), _t = (n, t, e) => new Promise((o, i) => {
  var l = (c) => {
    try {
      p(e.next(c));
    } catch (d) {
      i(d);
    }
  }, a = (c) => {
    try {
      p(e.throw(c));
    } catch (d) {
      i(d);
    }
  }, p = (c) => c.done ? o(c.value) : Promise.resolve(c.value).then(l, a);
  p((e = e.apply(n, t)).next());
});
const Xt = (n, t, e, o) => {
  var i, l, a;
  const [p, c] = j(!1), [d, m] = j("init"), { state: f } = $.useContext(), [s, g] = j(n);
  U(
    (r) => _t(void 0, null, function* () {
      g(yield t(r));
    }),
    {
      pollingInterval: 60 * 1e3,
      auto: !0
    }
  );
  const b = (i = s == null ? void 0 : s.present_to_shopper_details) == null ? void 0 : i.payment_code, I = (l = s == null ? void 0 : s.present_to_shopper_details) == null ? void 0 : l.channel_url;
  A(() => {
    (s == null ? void 0 : s.status) && s.status !== d && (s.status !== "init" || d !== "expired") && m(s.status);
  }, [s == null ? void 0 : s.status, d]);
  const _ = x(() => Z({
    amount: s == null ? void 0 : s.amount,
    currency: s == null ? void 0 : s.currency,
    locale: f.locale
  }), [s == null ? void 0 : s.currency, s == null ? void 0 : s.amount]), E = x(() => {
    const r = s.charge_details;
    return r && r.payment_method_details ? JSON.parse(
      r.payment_method_details
    ).iban : "";
  }, [(a = s == null ? void 0 : s.charge_details) == null ? void 0 : a.payment_method_details]), C = x(() => b && b.length > 4 ? ne(b, 4).join(" ") : "", [b]), h = () => {
    m("expired"), c(!0);
  }, { copy: T } = Fe({
    onSuccess() {
      o && o();
    }
  }), M = () => {
    var r, P, V, J;
    e && e({
      name: "fp_sdk_checkout_payment_code_click",
      categories: {
        click_method: "copy_code",
        pi_type_1: ((r = s.payment_method_info) == null ? void 0 : r.payment_method_type) || "",
        pi_type_2: ((P = s.payment_method_info) == null ? void 0 : P.payment_method) || "",
        pi_type_3: ((V = s.present_to_shopper_details) == null ? void 0 : V.bank_code) || "",
        pm_id: ((J = s.payment_method_info) == null ? void 0 : J.payment_method_id) || ""
      }
    }), T(b);
  }, y = () => {
    const { iban: r } = s.present_to_shopper_details;
    T(r);
  }, O = () => {
    window.open(I, "_blank");
  }, L = (r) => {
    const P = document.createElement("a");
    P.setAttribute("href", r), P.setAttribute("download", "preview"), P.setAttribute("id", "aTagForDownload"), document.getElementById("aTagForDownload") && document.body.removeChild(
      document.getElementById("aTagForDownload")
    ), document.body.appendChild(P), P.click();
  };
  return { defaultVoucherProps: {
    paymentDetail: ut(pt({}, s), {
      amount: _,
      expired: p,
      orderStatus: d,
      formatCode: C,
      userIban: E
    }),
    onQueryOrder: t,
    onExpire: h,
    onCopyCode: M,
    onCopyBankIban: y,
    onClickPaymentLink: O,
    onDownloadQRCode: L,
    onSendEvent: e
  } };
}, Zt = (n) => {
  const { list: t, init: e, onSelectPaymentMethod: o } = n, { isSelected: i, select: l, selected: a, unSelectAll: p, toggle: c } = Me(
    t,
    {
      isMulti: !1
    }
  );
  return A(() => {
    e && (l(e), o == null || o(e));
  }, [t]), { isSelected: i, select: l, selected: a, unSelectAll: p, toggle: c };
};
var mt = Object.defineProperty, yt = Object.defineProperties, ht = Object.getOwnPropertyDescriptors, me = Object.getOwnPropertySymbols, ft = Object.prototype.hasOwnProperty, gt = Object.prototype.propertyIsEnumerable, ye = (n, t, e) => t in n ? mt(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e, he = (n, t) => {
  for (var e in t || (t = {}))
    ft.call(t, e) && ye(n, e, t[e]);
  if (me)
    for (var e of me(t))
      gt.call(t, e) && ye(n, e, t[e]);
  return n;
}, fe = (n, t) => yt(n, ht(t));
const vt = [], en = (n) => {
  var t;
  const { t: e, state: o } = $.useContext(), i = Boolean((t = o.amount) == null ? void 0 : t.value), {
    formatPaymentMethodList: l,
    formatStoredPaymentMethodList: a,
    formatUnavailableOtherPaymentMethodList: p,
    mergeList: c = vt
  } = n, d = Re(
    c
  ), m = B(
    (s) => (d.includes(
      s.paymentMethodType.paymentMethodType
    ) || re(s)) && !ee.includes(s.paymentMethod.paymentMethodId),
    [d]
  );
  return x(() => {
    if (n.paymentMethodItemsMap)
      return n.paymentMethodItemsMap;
    const s = [];
    l.forEach((_, E) => {
      var C, h, T;
      if (m(_)) {
        if (!(s.findIndex(
          (O) => _.paymentMethodType.paymentMethodType === O.paymentMethodType.paymentMethodType && !ee.includes(
            O.paymentMethod.paymentMethodId
          )
        ) !== -1)) {
          const O = _.paymentMethodType.paymentMethodType, L = l.filter(
            (r) => O === "CCDC" ? re(r) : r.paymentMethodType.paymentMethodType === O
          ).filter(
            (r) => !ee.includes(
              r.paymentMethod.paymentMethodId
            )
          ), v = L.filter((r) => r.defaultSelected).length === 1;
          s.push(fe(he({}, _), {
            subPaymentMethodList: L,
            needMerge: !0,
            needExpand: d.includes(
              _.paymentMethodType.paymentMethodType
            ),
            iconList: L.map(
              (r) => {
                var P;
                return ((P = r.paymentMethod.icon) == null ? void 0 : P.grayIconUrl) || r.paymentMethod.icon.iconUrl;
              }
            ),
            key: E,
            btnText: e(((C = _.paymentMethodType.title) == null ? void 0 : C.piListShort) || "") || _.paymentMethodType.displayName || e(_.paymentMethodType.starling_key || ""),
            defaultSelectedParent: v
          }));
        }
      } else
        s.push(fe(he({}, _), {
          subPaymentMethodList: [],
          needMerge: !1,
          needExpand: !1,
          iconList: [
            ((h = _.paymentMethod.icon) == null ? void 0 : h.grayIconUrl) || _.paymentMethod.icon.iconUrl
          ],
          key: E,
          btnText: e(((T = _.paymentMethod.title) == null ? void 0 : T.piListShort) || "") || _.paymentMethod.displayName || e(_.paymentMethod.starling_key || "")
        }));
    });
    const g = p.filter((_) => {
      if (m(_)) {
        const C = s.find(
          (h) => _.paymentMethodType.paymentMethodType === h.paymentMethodType.paymentMethodType
        );
        return C && (C.subUnavailablePaymentMethodList ? C.subUnavailablePaymentMethodList.push(
          _
        ) : C.subUnavailablePaymentMethodList = [_]), !1;
      }
      return !0;
    }), b = a.filter(
      (_) => (_ == null ? void 0 : _.isAgreementBound) !== !1
    ), I = a.filter(
      (_) => (_ == null ? void 0 : _.isAgreementBound) === !1
    );
    return {
      uiOtherUnavailablePaymentMethodList: g,
      uiOtherPaymentMethodList: s,
      uiStoredPaymentMethodList: i ? a : b,
      uiStoredUnboundPaymentMethodList: I,
      uiPaymentMethodsList: [
        ...a,
        ...s
      ]
    };
  }, [
    l,
    a,
    p,
    d,
    m,
    n.paymentMethodItemsMap,
    e,
    i
  ]);
};
function tn(n) {
  const { t } = $.useContext(), e = "individual", o = t("pipo_common_payin_proxy_type"), i = (a) => !a || a === "individual" || a === "company", l = B(
    (a, p) => {
      a === "individual" ? n("company_id") : a === "company" && n("identity"), p(a);
    },
    []
  );
  return {
    defaultProxyType: e,
    proxyTypeTitle: o,
    proxyTypeValidator: i,
    onProxyTypeChange: l
  };
}
var bt = Object.defineProperty, ge = Object.getOwnPropertySymbols, Pt = Object.prototype.hasOwnProperty, Mt = Object.prototype.propertyIsEnumerable, ve = (n, t, e) => t in n ? bt(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e, H = (n, t) => {
  for (var e in t || (t = {}))
    Pt.call(t, e) && ve(n, e, t[e]);
  if (ge)
    for (var e of ge(t))
      Mt.call(t, e) && ve(n, e, t[e]);
  return n;
};
const Ct = /* @__PURE__ */ new Set(["GB", "US", "CA"]), nn = (n, t) => {
  const { state: e, noSavingBox: o } = $.useContext(), { countryOrRegion: i, config: l = {} } = e, { ccdc: a = {} } = l, {
    mode: p = 1,
    showSavingBox: c = !o,
    showTitle: d = !0,
    showPayBtn: m = !0,
    onSendEvent: f
  } = H(H({}, a), n), s = a.dynamic || !1, g = t("proxy_type"), b = {
    hasSavingBox: c,
    hasTitle: d,
    hasPayBtn: m
  }, I = x(() => {
    const C = i === "BR", {
      showEmail: h = !1,
      hasCNPJ: T = !0,
      hasBillingAddress: M = !0
    } = H(H({}, a), n), y = C && p === 2, O = C || h, L = C && p === 2, v = C && (p === 1 || p === 2 && g === "individual"), r = C && p === 2 && g === "company", P = M && (Ct.has(i) || C && p === 2);
    return {
      hasCNPJ: T,
      hasPhoneNumber: y,
      hasEmail: O,
      hasProxyType: L,
      hasCPF: v,
      renderCNPJ: r,
      renderBillingInfo: P,
      hasBillingAddressCountry: !0,
      hasBillingAddressState: !0,
      hasBillingAddressCity: !0,
      hasBillingAddressStreet: !0,
      hasPostalCode: !0
    };
  }, [a, i, p, n, g]), _ = x(() => {
    if (!s)
      return I;
    const {
      hasProxyType: C = !1,
      hasCNPJ: h = !1,
      hasCPF: T = !1,
      hasEmail: M = !1,
      hasPhoneNumber: y = !1,
      hasBillingAddress: O = !1,
      hasBillingAddressStreet: L = !1,
      hasPostalCode: v = !1,
      limitAddressLevel: r = 2
    } = a;
    return {
      hasCNPJ: h,
      hasPhoneNumber: y,
      hasEmail: M,
      hasProxyType: C,
      hasCPF: C ? T && g === "individual" : T,
      renderCNPJ: (C ? h && g === "company" : h) || !1,
      renderBillingInfo: O || L || v || !1,
      hasBillingAddressCountry: O && r >= 0,
      hasBillingAddressState: O && r >= 1,
      hasBillingAddressCity: O && r >= 2,
      hasBillingAddressStreet: L,
      hasPostalCode: v
    };
  }, [a, s, I, g]), E = s ? _ : I;
  return A(() => {
    if (f && s) {
      let C = !0;
      const h = {};
      Object.keys(I).forEach((T) => {
        const M = I[T] === _[T];
        C = C && M, h[`${T}Match`] = `${M}`;
      }), h.all = `${C}`, f({
        name: "dynamicFormConfig",
        eventType: "slardar",
        categories: H({}, h)
      });
    }
  }, [_.renderCNPJ]), H(H({}, b), E);
}, on = () => {
  const n = je(!1);
  return {
    isSubmitting: n.state,
    formSubmitState: n
  };
}, Tt = /* @__PURE__ */ new Set([
  "pm_pi_cp_dailyyamazaki_c_d",
  "pm_pi_cp_seveneleven_c_d",
  "pm_pi_cp_lawson_c_d",
  "pm_pi_cp_ministop_c_d",
  "pm_pi_cp_seicomart_c_d",
  "pm_pi_cp_familymart_c_d"
]), Lt = "pipo_common_payin_degicanotify", It = /* @__PURE__ */ new Set([
  "pm_pi_cp_oxxo_c_d",
  "pm_pi_cp_indomaret_c_d",
  "pm_pi_cp_alfa_c_d",
  "pm_pi_cp_fawry_c_d"
]), rn = (n) => {
  const {
    formatCode: t,
    amount: e,
    currency: o,
    shopperDetails: i,
    paymentMethodId: l,
    chargeDetails: a
  } = n, p = K[l].paymentMethod.paymentMethod, c = K[l].paymentMethodType.paymentMethodType, { t: d, state: m } = $.useContext(), {
    confirmation_code: f = "",
    payment_code: s = "",
    payment_method_fee: g = "",
    total: b = "",
    instructions_url: I = "",
    holder_name: _ = ""
  } = i, E = x(() => f !== "" && f.length > 4 ? ne(f, 4).join(" ") : void 0, [f]), C = x(() => s !== "" && s.length > 4 ? ne(s, 4).join(" ") : void 0, [s]), h = x(() => o && g ? Z({
    amount: g,
    currency: o,
    locale: m.locale
  }) : void 0, [b, o]), T = x(() => o && b ? Z({
    amount: b,
    currency: o,
    locale: m.locale
  }) : void 0, [b, o]), M = x(() => o && (a == null ? void 0 : a.charge_amount) ? Z({
    amount: a.charge_amount,
    currency: o,
    locale: m.locale
  }) : "--", [a == null ? void 0 : a.charge_amount, o, m.locale]), y = x(() => c === "BANK_TRANSFER" ? d("pipo_payin_paymentcode_nameofbank") : c === "CASH_PIN" ? d("pipo_common_payin_conveniencestore") : void 0, [l]);
  return Tt.has(l) ? {
    type: "complicated",
    paymentMethodInfo: {
      paymentMethodId: l,
      paymentMethod: p,
      paymentMethodType: c,
      bankId: i.bank_code
    },
    simple: { formatCode: "", amount: "", hasCopyButton: !1 },
    complicated: {
      formatCustomerNo: E,
      formatPaymentCode: C,
      formatOrderFee: e,
      formatTransactionFee: h,
      formatTotalFee: T
    },
    hint: d(Lt),
    instructionUrl: I,
    config: {
      codeTitle: d("pipo_common_payin_mobile_basicinfo_title"),
      paymentInfoTitle: y
    }
  } : l === "pm_pi_bt_banktransfertoss_c_d" ? {
    type: "complicated",
    paymentMethodInfo: {
      paymentMethodId: l,
      paymentMethod: p,
      paymentMethodType: c,
      bankId: i.bank_code
    },
    simple: { formatCode: "", amount: "", hasCopyButton: !0 },
    complicated: {
      formatPaymentCode: C,
      formatTotalFee: M,
      holderName: _
    },
    config: {
      codeTitle: d("pipo_payin_logo_tossVA"),
      paymentInfoTitle: y
    }
  } : {
    type: "simple",
    paymentMethodInfo: {
      paymentMethodId: l,
      paymentMethod: p,
      paymentMethodType: c,
      bankId: i.bank_code
    },
    simple: {
      formatCode: t,
      amount: M,
      hasCopyButton: !It.has(l)
    },
    complicated: {},
    config: {
      codeTitle: d("pipo_payin_paymentcode_paymentcode"),
      paymentInfoTitle: y
    }
  };
};
function an(n) {
  const { touchedFields: t, errors: e } = n, o = qe(t);
  return Ge(
    e,
    o
  );
}
const sn = (n) => {
  const { handleSelect: t, uiPaymentMethodsList: e, uiStoredPaymentMethodList: o } = n;
  A(() => {
    var i;
    const l = e.filter(
      (a) => (a == null ? void 0 : a.defaultSelected) || (a == null ? void 0 : a.defaultSelectedParent)
    );
    if (l.length === 1) {
      const a = l[0];
      if (a.defaultSelected)
        t(a);
      else {
        const p = a, c = (i = p == null ? void 0 : p.subPaymentMethodList) == null ? void 0 : i.find(
          (d) => d == null ? void 0 : d.defaultSelected
        );
        t(c, "PaymentMethodExtra");
      }
    }
  }, [e]);
}, ln = (n) => {
  var t;
  const { onFetchDistrict: e, getValues: o, setValue: i, trigger: l, clearErrors: a, watch: p } = n, { t: c } = $.useContext(), {
    data: d = [],
    loading: m
  } = U(() => e("6251999"), {
    auto: !0
  }), {
    data: f = [],
    loading: s,
    run: g,
    changeData: b
  } = U(e, {
    onSuccess: (C = []) => {
      const h = f.filter(
        (T) => !(T.code === "" && T.name === "")
      );
      if (h.length === 0) {
        const T = d.filter(
          (M) => {
            var y;
            return M.name === ((y = o()) == null ? void 0 : y.bank_address_state);
          }
        )[0];
        b([...h, T]);
      }
      i("bank_address_city", void 0), l("bank_address_city");
    }
  });
  A(() => {
    var C, h;
    i("bank_address_city", void 0), b([]), (C = o()) != null && C.bank_address_state && (a("bank_address_city"), g(
      (h = d == null ? void 0 : d.find((T) => {
        var M;
        return T.name === ((M = o()) == null ? void 0 : M.bank_address_state);
      })) == null ? void 0 : h.geoname_id.toString()
    ));
  }, [p("bank_address_state"), d]);
  const I = {
    label: c("pipo_common_payin_country"),
    disabled: !1,
    loading: !1,
    list: []
  }, _ = {
    label: c("pipo_common_payin_statecity_ca"),
    loading: m,
    list: d,
    disabled: !1
  }, E = {
    label: c("pipo_common_payin_citytown_ca"),
    loading: s,
    list: f,
    disabled: !s && !((t = o()) != null && t.bank_address_state)
  };
  return {
    list: G([I, _, E], Boolean),
    map: G(
      {
        region: I,
        province: _,
        city: E
      },
      Boolean
    )
  };
}, dn = (n) => {
  var t, e;
  const {
    onFetchDistrict: o,
    getValues: i,
    setValue: l,
    trigger: a,
    clearErrors: p,
    watch: c,
    countryOrRegion: d
  } = n, { t: m } = $.useContext(), { data: f = [], loading: s } = U(() => o(""), {
    auto: !0
  }), {
    data: g = [],
    loading: b,
    run: I,
    changeData: _
  } = U(o, {
    onSuccess: () => {
      const L = g.filter(
        (v) => !(v.code === "" && v.name === "")
      );
      if (L.length === 0) {
        const v = f.filter(
          (r) => {
            var P;
            return r.code === ((P = i()) == null ? void 0 : P.billing_country_region);
          }
        )[0];
        _([...L, v]);
      }
      l("billing_state", void 0);
    }
  }), {
    data: E = [],
    loading: C,
    run: h,
    changeData: T
  } = U(o, {
    onSuccess: () => {
      const L = E.filter(
        (v) => !(v.code === "" && v.name === "")
      );
      if (L.length === 0) {
        const v = g.filter(
          (r) => {
            var P;
            return r.name === ((P = i()) == null ? void 0 : P.billing_state);
          }
        )[0];
        T([...L, v]);
      }
      l("billing_city", void 0), a("billing_city");
    }
  });
  A(() => {
    if (!!f.length)
      return l("billing_country_region", d), a("billing_country_region"), () => {
        l("billing_country_region", void 0), l("billing_state", void 0), l("billing_city", void 0);
      };
  }, [f]), A(() => {
    var L, v;
    l("billing_state", void 0), l("billing_city", void 0), _([]), T([]), (L = i()) != null && L.billing_country_region && (p(["billing_state", "billing_city"]), I(
      (v = f == null ? void 0 : f.find((r) => {
        var P;
        return r.code === ((P = i()) == null ? void 0 : P.billing_country_region);
      })) == null ? void 0 : v.geoname_id.toString()
    ));
  }, [c("billing_country_region")]), A(() => {
    var L, v;
    l("billing_city", void 0), T([]), (L = i()) != null && L.billing_state && (p("billing_city"), h(
      (v = g == null ? void 0 : g.find((r) => {
        var P;
        return r.name === ((P = i()) == null ? void 0 : P.billing_state);
      })) == null ? void 0 : v.geoname_id.toString()
    ));
  }, [c("billing_state"), g]);
  const M = {
    label: m("pipo_common_payin_country"),
    loading: s,
    list: f,
    disabled: !1
  }, y = {
    label: d.toLowerCase() === "br" ? m("pipo_common_payin_statecity") : m(
      `pipo_common_payin_statecity_${d.toLowerCase() || "us"}`
    ),
    loading: b,
    list: g,
    disabled: !b && !((t = i()) != null && t.billing_country_region)
  }, O = {
    label: d.toLowerCase() === "br" ? m("pipo_common_payin_citytown") : m(
      `pipo_common_payin_citytown_${d.toLowerCase() || "us"}`
    ),
    loading: C,
    list: E,
    disabled: !C && !((e = i()) != null && e.billing_state)
  };
  return {
    list: G([M, y, O], Boolean),
    map: G(
      {
        region: M,
        province: y,
        city: O
      },
      Boolean
    )
  };
};
var St = Object.defineProperty, wt = Object.defineProperties, Ot = Object.getOwnPropertyDescriptors, be = Object.getOwnPropertySymbols, Et = Object.prototype.hasOwnProperty, Dt = Object.prototype.propertyIsEnumerable, Pe = (n, t, e) => t in n ? St(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e, xt = (n, t) => {
  for (var e in t || (t = {}))
    Et.call(t, e) && Pe(n, e, t[e]);
  if (be)
    for (var e of be(t))
      Dt.call(t, e) && Pe(n, e, t[e]);
  return n;
}, Nt = (n, t) => wt(n, Ot(t)), At = (n, t, e) => new Promise((o, i) => {
  var l = (c) => {
    try {
      p(e.next(c));
    } catch (d) {
      i(d);
    }
  }, a = (c) => {
    try {
      p(e.throw(c));
    } catch (d) {
      i(d);
    }
  }, p = (c) => c.done ? o(c.value) : Promise.resolve(c.value).then(l, a);
  p((e = e.apply(n, t)).next());
});
const cn = (n) => {
  const {
    onFetchAddressAutocomplete: t,
    onFetchPlaceDetail: e,
    value: o,
    onChange: i,
    autoCompleteDisabled: l
  } = n, a = o == null ? void 0 : o.billing_country_region, p = o == null ? void 0 : o.billing_street, c = l || !t || !e || !a || !p, { data: d = [], loading: m } = U(
    () => t(a, p),
    {
      ready: !c,
      auto: !0,
      debounceInterval: 500,
      refreshDeps: [a, p, t]
    }
  );
  return {
    autoCompleteDisabled: c,
    autoCompleteList: d,
    autoCompleteLoading: m,
    onClickAutoComplete: (s) => At(void 0, null, function* () {
      if (!!e)
        try {
          const g = yield e(s), b = g.postcode && Be(g.postcode), I = g.adm1.name, _ = g.adm2.name || I, E = g.address || (o == null ? void 0 : o.billing_street);
          i(Nt(xt({}, o), {
            billing_postal_code: b,
            billing_state: I,
            billing_city: _,
            billing_street: E
          }));
        } catch (g) {
        }
    })
  };
}, Bt = {
  E_WALLET: 5,
  INTERNET_BANKING: 2,
  CASH_PIN: 2,
  DIRECT_DEBIT: 1
}, pn = ({
  formatPaymentMethodList: n,
  config: t = Bt
}) => x(() => {
  const e = [];
  return Object.keys(t).forEach((o) => {
    n.filter(
      (l) => l.paymentMethodType.paymentMethodType === o && !ee.includes(l.paymentMethod.paymentMethodId)
    ).length >= t[o] && e.push(o);
  }), e;
}, [t, n]), un = () => {
  const [n, t] = j(), [e, o] = j();
  return { onFormStateChange: B(
    (l, a) => {
      t(l), o(() => a);
    },
    []
  ), isValid: n, onElementSubmit: e };
}, _n = He;
export {
  Bt as DEFAULT_MERGE_CONFIG,
  Wt as useAddress,
  cn as useAddressAutocomplete,
  dn as useAddressPC,
  nn as useCCDCFormConfig,
  qt as useCardNumber,
  ln as useCitiAddress,
  _n as useControlled,
  Qt as useCountdownTimer,
  pn as useCustomMerge,
  sn as useDefaultSelect,
  un as useElementFormSubmit,
  Gt as useExpiryDate,
  Jt as useExpiryDateError,
  Ht as useFormatPayment,
  zt as usePipoRouter,
  Kt as usePostalCode,
  tn as useProxyType,
  Yt as useSecurityCode,
  Zt as useSelectPayment,
  on as useSubmittingState,
  an as useTouchedErrors,
  en as useUIPaymentMethods,
  rn as useUIVoucher,
  nt as useValidateCallback,
  Xt as useVoucher
};
